import { motion } from "framer-motion";
import { IMAGES, PILLARS } from "../../data/content";
import { reveal } from "../../lib/motion";

const marqueePills = [...PILLARS, ...PILLARS, ...PILLARS, ...PILLARS];

export const Movement = () => {
  return (
    <>
      {/* Seção 2 — O Ministério */}
      <section id="movimento" className="bg-cream py-16 md:py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
          <motion.p
            {...reveal()}
            className="text-xs font-semibold uppercase tracking-[0.3em] text-gold"
          >
            O Ministério
          </motion.p>
          <motion.h2
            {...reveal(0.1)}
            className="mt-4 max-w-4xl font-serif text-3xl leading-tight text-ink sm:text-4xl lg:text-5xl"
          >
            Um ministério. Uma rede. Uma comunidade. Uma plataforma.{" "}
            <em className="italic text-teal">Um movimento.</em>
          </motion.h2>
          <motion.p
            {...reveal(0.2)}
            className="mt-6 max-w-3xl text-base leading-relaxed text-mutedink sm:text-lg"
          >
            O AURA nasce para reunir mulheres cristãs de todas as gerações,
            profissões e histórias em um só lugar: um espaço sagrado de conexão,
            cuidado e prosperidade, onde cada mulher descobre quem é, ocupa o
            seu lugar e serve ao mundo com o que tem de mais precioso.
          </motion.p>
        </div>

        <motion.div {...reveal(0.3)} className="relative mt-14 overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-cream to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-cream to-transparent" />
          <div className="flex w-max animate-marquee gap-4">
            {marqueePills.map((pillar, i) => (
              <span
                key={`${pillar}-${i}`}
                className="rounded-full border border-gold-border bg-white px-7 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-teal hover:text-white"
              >
                {pillar}
              </span>
            ))}
          </div>
        </motion.div>
      </section>

      {/* Seção 3 — A Grande Visão */}
      <section className="bg-creamalt py-16 md:py-24 lg:py-32">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
          <motion.div {...reveal()} className="relative">
            <div className="gold-hairline absolute -top-6 left-1/2 w-2/3 -translate-x-1/2" />
            <div className="arch-frame overflow-hidden border border-gold-border">
              <img
                src={IMAGES.community1}
                alt="Mulheres da comunidade AURA reunidas"
                className="h-[420px] w-full object-cover object-[center_15%] sm:h-[520px]"
              />
            </div>
            <div className="animate-float-soft absolute -bottom-6 left-1/2 -translate-x-1/2 rounded-2xl border border-gold-border bg-white px-8 py-5 text-center shadow-[0_20px_60px_rgba(197,160,89,0.12)]">
              <p className="font-serif text-4xl text-teal">12</p>
              <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.25em] text-mutedink">
                Fundadoras Miss Aura
              </p>
            </div>
          </motion.div>

          <div>
            <motion.p
              {...reveal()}
              className="text-xs font-semibold uppercase tracking-[0.3em] text-gold"
            >
              A Grande Visão
            </motion.p>
            <motion.h2
              {...reveal(0.1)}
              className="mt-4 font-serif text-3xl leading-tight text-ink sm:text-4xl lg:text-5xl"
            >
              "Uma mulher transforma uma família.{" "}
              <em className="italic text-gold">Mulheres transformam uma geração."</em>
            </motion.h2>
            <motion.p
              {...reveal(0.2)}
              className="mt-6 text-base leading-relaxed text-mutedink sm:text-lg"
            >
              Nossa visão é construir uma das maiores redes de mulheres cristãs
              do mundo — mulheres conectadas, apoiadas e prosperando juntas, da
              fé aos negócios, do cuidado ao legado.
            </motion.p>
            <motion.div {...reveal(0.3)} className="mt-10 space-y-5">
              {[
                ["7", "Pilares de vida"],
                ["10+", "Categorias de serviço"],
                ["1", "Propósito eterno"],
              ].map(([num, label]) => (
                <div key={label} className="flex items-baseline gap-4 border-l-2 border-gold pl-5">
                  <span className="font-serif text-3xl text-teal sm:text-4xl">{num}</span>
                  <span className="text-sm uppercase tracking-[0.15em] text-mutedink">{label}</span>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};
